import React from "react";
import { useParams } from "react-router-dom";
import { useRoutes } from "utils/routes";

import PageSecondaryNavigation, {
  PageNavLink,
} from "ui/PageSecondaryNavigation";
import OrganizationWorkbookList from "features/Workbooks/OrganizationWorkbookList";
import ServerGroupWorkbookList from "features/Workbooks/ServerGroupWorkbookList";
import ServerWorkbookList from "features/Workbooks/ServerWorkbookList";
import WorkbookList from "features/Workbooks/WorkbookList";
import PageContent from "ui/PageContent";
import { useFeature } from "providers/OrganizationFeatures";
import UpgradeRequired from "ui/UpgradeRequired";

const QueryTuning = () => {
  const { databaseId, serverId, serverGroupId, slug } = useParams();
  const {
    databaseWorkbooks,
    serverWorkbooks,
    serverGroupWorkbooks,
    organizationWorkbooks,
  } = useRoutes();
  const hasWorkbooks = useFeature("workbooks");

  const navLink = databaseId
    ? databaseWorkbooks(databaseId)
    : serverId
    ? serverWorkbooks(serverId)
    : serverGroupId
    ? serverGroupWorkbooks(serverGroupId)
    : slug
    ? organizationWorkbooks(slug)
    : null;

  const featureNav = navLink ? (
    <PageSecondaryNavigation>
      <PageNavLink to={navLink}>Query Tuning</PageNavLink>
    </PageSecondaryNavigation>
  ) : null;

  const body = databaseId ? (
    <WorkbookList />
  ) : serverId ? (
    <ServerWorkbookList />
  ) : serverGroupId ? (
    <ServerGroupWorkbookList />
  ) : (
    <OrganizationWorkbookList />
  );

  return hasWorkbooks ? (
    <PageContent
      title="Workbooks"
      pageCategory="workbooks"
      pageName="index"
      featureNav={featureNav}
    >
      {body}
    </PageContent>
  ) : (
    <UpgradeRequired feature="Workbooks" />
  );
};

export default QueryTuning;
